import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import like from '../images/icons/like.svg';
import dislike from '../images/icons/dislike.svg';
import commentss from '../images/icons/comments.svg';
import viewss from '../images/icons/views.svg';

function Blogcard({ id, image, category, title, author, date, likes, comments, views }) {
  const [liked, setLiked] = useState(false);
  const [likeCount, setLikeCount] = useState(likes);

  // Check if blog was liked in cookies
  useEffect(() => {
    const likedBlogs = Cookies.get('likedBlogs');
    if (likedBlogs) {
      const likedArray = JSON.parse(likedBlogs);
      if (likedArray.includes(id)) {
        setLiked(true);
      }
    }
  }, [id]);

  const updateCookies = (newLikedState) => {
    let likedArray = [];
    const existing = Cookies.get('likedBlogs');
    if (existing) {
      likedArray = JSON.parse(existing);
    }

    if (newLikedState) {
      if (!likedArray.includes(id)) likedArray.push(id);
    } else {
      likedArray = likedArray.filter((blogId) => blogId !== id);
    }

    Cookies.set('likedBlogs', JSON.stringify(likedArray), { expires: 365 });
  };

  const handleLikeToggle = async (e) => {
    e.stopPropagation();
    const newLiked = !liked;
    const type = newLiked ? 'add' : 'minus';

    // Optimistic UI update
    setLiked(newLiked);
    setLikeCount((prev) => (newLiked ? parseInt(prev) + 1 : parseInt(prev) - 1));
    updateCookies(newLiked);

    try {
      await axios.post(`${process.env.REACT_APP_BASE_URL}/blogs/${id}/likes`, { type });
    } catch (err) {
      console.error('Failed to update like status:', err);
      // Optionally revert UI on failure
    }
  };

  const goSingle = () => {
    window.location.href = `/blogs/${id}`;
  };

  return (
    <div onClick={goSingle} className='rounded-[8px] flex flex-col space-y-3 cursor-pointer mb-3'>
      <div className='flex flex-col space-y-1 w-full'>
        <div className='h-[285px]'>
          <img className='rounded-[8px] h-[280px] w-full' src={image} alt={title} />
        </div>
        <div className='text-[#008B39] text-start text-[16px] font-[400] flex flex-row justify-between'>
          <span>{category}</span>
          <div className='flex flex-row space-x-3 items-center'>
            <div className='flex flex-row space-x-1 items-center' onClick={handleLikeToggle}>
              <span><img src={liked ? like : dislike} alt="like icon" /></span>
              <span className='text-[#323232] text-[14px] font-[400]'>{likeCount}</span>
            </div>
            <div className='flex flex-row space-x-1 items-center'>
              <span><img src={viewss} alt="views icon" /></span>
              <span className='text-[#323232] text-[14px] font-[400]'>{views}</span>
            </div>
            <div className='flex flex-row space-x-1 items-center'>
              <span><img src={commentss} alt="comments icon" /></span>
              <span className='text-[#323232] text-[14px] font-[400]'>{comments}</span>
            </div>
          </div>
        </div>
      </div>
      <div className='text-[#121927] text-[20px] lg:text-[24px] font-[500] text-start lg:w-[350px]'>{title}</div>
      <div className='flex flex-row justify-between items-center'>
        <span className='text-[16px] text-[#333333] font-[400]'>By Yebokenny</span>
        <span className='text-[16px] text-[#828282] font-[400]'>{date}</span>
      </div>
    </div>
  );
}

export default Blogcard;
